/**
* Marquee CTA JS
* -----------------------------------------------------------------------------
*
* All the JS for the Marquee CTA component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
import Splide from '@splidejs/splide';
import {AutoScroll} from '@splidejs/splide-extension-auto-scroll';
( function( app ) {
  const COMPONENT = {

    className: 'marquee-cta',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      if ( $( '.marquee-cta__slider' ).length ) {
        $( '.marquee-cta__slider' ).each( function( index, element ) {
          const slider = new Splide( $( element )[0], {
            type: 'loop',
            drag: false,
            focus: 'center',
            perPage: 1,
            gap: `18px`,
            autoWidth: true,
            arrows: false,
            pagination: false,
            autoScroll: {
              speed: .35,
              pauseOnFocus: false,
              pauseOnHover: false,
            },
          } );
          slider.mount( {AutoScroll} );
        } );
      }

      if ( $( '.marquee-cta__reverse-slider' ).length ) {
        $( '.marquee-cta__reverse-slider' ).each( function( index, element ) {
          const slider = new Splide( $( element )[0], {
            type: 'loop',
            drag: false,
            focus: 'center',
            perPage: 1,
            gap: `18px`,
            autoWidth: true,
            arrows: false,
            pagination: false,
            direction: 'rtl',
            autoScroll: {
              speed: .35,
              pauseOnFocus: false,
              pauseOnHover: false,
            },
          } );
          slider.mount( {AutoScroll} );
        } );
      }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'marquee-cta', COMPONENT );
} )( app );
